import React from 'react';
import PageHero from '../components/ui/PageHero';
import SEO from '../components/SEO';

const MentionsLegalesPage = () => {
  return (
    <div>
      <SEO 
        title="Mentions Légales"
        description="Mentions légales du site Mon Evénemenciel. Informations sur l'éditeur, l'hébergeur et la propriété intellectuelle."
        keywords="mentions légales, Mon Evénemenciel, informations légales"
        url="/mentions-legales"
      />
      <PageHero
        title="Mentions Légales"
        subtitle=""
        backgroundImage="/img/photo-evenement.webp"
      />

      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-gray max-w-none">
            
            {/* Éditeur du site */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#96452f] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                Éditeur du site
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70 mb-2">
                  Le site <strong>monevenemenciel.eu</strong> est édité par :
                </p>
                <ul className="text-brand-petrol/70 space-y-1 ml-4">
                  <li><strong>Raison sociale :</strong> MonEvenemenciel</li>
                  <li><strong>Forme juridique :</strong> SAS (Société par Actions Simplifiée)</li>
                  <li><strong>Capital social :</strong> 1 000 €</li>
                  <li><strong>Siège social :</strong> B36 Allée des Prêts Rouets, 69510 Messimy, France</li>
                  <li><strong>SIREN :</strong> 851 986 877</li>
                  <li><strong>SIRET :</strong> 851 986 877 00021</li>
                  <li><strong>RCS :</strong> 851 986 877 R.C.S. Lyon</li>
                  <li><strong>N° TVA Intracommunautaire :</strong> FR70851986877</li>
                </ul>
              </div>
            </div>

            {/* Directeurs de la publication */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#D08154] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                Directeurs de la publication
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70">
                  <strong>Alexis RAUSCH</strong> et <strong>Christophe GARNIER</strong>
                </p>
                <p className="text-brand-petrol/70 mt-2">
                  Contact : <a href="mailto:contact@monevenemenciel.eu" className="text-[#96452f] hover:underline">contact@monevenemenciel.eu</a>
                </p>
              </div>
            </div>

            {/* Hébergement */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#96452f] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                Hébergement
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70 mb-2">
                  Le Site est hébergé par <strong>SharpHeberg</strong>, dont les serveurs sont localisés en France dans le centre de données Equinix PA5, situé 254 rue du Mimosa, 93300 Aubervilliers.
                </p>
                <p className="text-brand-petrol/70">
                  Contact hébergeur : <a href="mailto:contact@sharpheberg.com" className="text-[#96452f] hover:underline">contact@sharpheberg.com</a>
                </p>
              </div>
            </div>

            {/* Propriété intellectuelle */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#D08154] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                Propriété intellectuelle
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70 mb-4">
                  L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, icônes, etc.) est la propriété exclusive de MonEvenemenciel ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
                </p>
                <p className="text-brand-petrol/70">
                  Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, des éléments du site est strictement interdite sans autorisation écrite préalable de MonEvenemenciel.
                </p>
              </div>
            </div>

            {/* Responsabilité */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#96452f] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                Limitation de responsabilité
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70 mb-4">
                  MonEvenemenciel s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, MonEvenemenciel ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
                </p>
                <p className="text-brand-petrol/70">
                  MonEvenemenciel décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site, ainsi que pour tout dommage résultant d'une intrusion frauduleuse d'un tiers.
                </p>
              </div>
            </div>

            {/* Liens hypertextes */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#D08154] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                Liens hypertextes
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70">
                  Le site peut contenir des liens vers d'autres sites internet. MonEvenemenciel n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou aux éventuels dommages résultant de leur utilisation.
                </p>
              </div>
            </div>

            {/* Droit applicable */}
            <div className="mb-10">
              <h2 className="text-2xl font-display text-brand-petrol mb-4 flex items-center">
                <span className="w-8 h-8 bg-[#96452f] text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                Droit applicable
              </h2>
              <div className="bg-brand-ivory rounded-xl p-6">
                <p className="text-brand-petrol/70">
                  Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </div>
            </div>

            {/* Date de mise à jour */}
            <div className="text-center mt-12 pt-8 border-t border-gray-200">
              <p className="text-gray-500 text-sm">
                Dernière mise à jour : Janvier 2025
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegalesPage;
